<p-table [value]="user" #schoolUsers>
  <ng-template pTemplate="header">
    <tr>
      <th class="align-left">Name</th>
      <th class="align-left" style="width: 40%">Email Address</th>
      <th class="align-left">Status</th>
      <th class="align-left">Access to Portal</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-user>
    <tr>
      @if (!noRecordMsgFlag) {
        <td class="overflow-wrap">
          {{
            user.firstName === null
              ? ""
              : user.firstName + " " + user.familyName
          }}
        </td>
        <td>{{ user.email }}</td>
        <td>{{ user.status }}</td>
        <td>{{ user.active }}</td>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="footer">
    @if (noRecordMsgFlag) {
      <tr>
        <td [attr.colspan]="4">No users found</td>
      </tr>
    }
  </ng-template>
</p-table>
